// extracted by mini-css-extract-plugin
export default {"button":"AeMNL","icon":"YDeVe","wrapper":"BkQ7I","label":"ckHiQ"};